import { BASE_URL_ONLINE_DOCS, DOC_HOST } from '../../base/constants/cgi-base';
/**
 * 拉取最近指定成员
 */
export var GET_RECENT_USER_INFO = "".concat(BASE_URL_ONLINE_DOCS, "user_recent");
/**
 * 发送文档给协作人
 */
export var SEND_DOC_TO_MEMBERS = "".concat(BASE_URL_ONLINE_DOCS, "auth_sendmsg");
/**
 * 导出到PC
 */
export var EXPORT_TO_PC = "".concat(DOC_HOST, "/cgi-go/common-notify/view");
/**
 * 已读列表
 */
export var BROWSER_LIST = "".concat(BASE_URL_ONLINE_DOCS, "browser_list");
// =================== 微信分享 ======================= //
/**
 * 添加微信分享链接个数
 */
export var ADD_WX_SHARE_COUNT = "".concat(DOC_HOST, "/v2/privilege/wxsharelink/save");
/**
 * 获取微信分享链接个数
 */
export var GET_WX_SHARE_COUNT = "".concat(DOC_HOST, "/v2/privilege/wxsharelink/get");
/**
 * 收回微信分享链接
 */
export var STOP_WX_SHARE = "".concat(DOC_HOST, "/v2/privilege/wxsharelink/recall");
/**
 * 二维码分享到微信/邀请微信好友协作
 */
export var WX_SHARE = "".concat(BASE_URL_ONLINE_DOCS, "wxqrcode");
// =================== QQ分享 ======================= //
/**
 * QQ群导入文档从引导tips邀请协作者后设置此标志位
 */
export var SET_TIPS_AFTER_IMPORT = "".concat(BASE_URL_ONLINE_DOCS, "qq_import/setTips");
/**
 * 分享到QQ或者TIM
 */
export var SHARE_QQ_TIM = "".concat(DOC_HOST, "/cgi-bin/online_docs/share_doc");
/**
 * 检查是否可以分享到QQ或TIM
 */
export var CHECK_IF_CAN_SHARE_TO_QQ = "".concat(BASE_URL_ONLINE_DOCS, "auth_info/update");
/**
 * 请求好友关系链
 */
export var GET_QQ_FRIENDS = "".concat(DOC_HOST, "/sdc/friends");
/**
 * 请求群成员
 */
export var GET_GROUP_MEMBER = "".concat(DOC_HOST, "/sdc/gmembers");
/**
 * 请求讨论组成员
 */
export var GET_DISCUSS_GROUP_MEMBER = "".concat(DOC_HOST, "/sdc/dmembers");
/**
 * 请求群信息
 */
export var GET_GROUP_INFO = "".concat(DOC_HOST, "/v2/group/getinfo");
/**
 * 请求好友信息
 */
export var GET_FRIEND_INFO = "".concat(DOC_HOST, "/v2/sdc/friendchat");
/**
 * 校验 QQ p_lskey, p_skey 有效性
 */
export var CHECK_SKEY_AUTH = "".concat(DOC_HOST, "/v2/util/qq/auth/check");
// =================== 千帆玉符分享 ======================= //
/**
 * 拉取千帆玉符组织架构
 */
export var GET_QFYF_STRUCTURE = "".concat(DOC_HOST, "/enterprise/v1/cig/departments");
/**
 * 千帆玉符搜索用户
 */
export var SEARCH_QFYF_USER = "".concat(DOC_HOST, "/enterprise/v1/cig/search-user");
// =================== 文档群组 ======================= //
/**
 * 查看我的群组
 */
export var GET_GROUP_LIST = "".concat(BASE_URL_ONLINE_DOCS, "group_list");
/**
 * 查看群组成员
 */
export var GET_GROUP_MEMBERS = "".concat(BASE_URL_ONLINE_DOCS, "group_members");
/**
 * 修改群组名称
 */
export var MODIFY_GROUP = "".concat(BASE_URL_ONLINE_DOCS, "group_modify");
/**
 * 删除群组成员
 */
export var DELETE_GROUP_MEMBER = "".concat(BASE_URL_ONLINE_DOCS, "group_deletemember");
/**
 * 解散群组
 */
export var REMOVE_GROUP = "".concat(BASE_URL_ONLINE_DOCS, "group_remove");
/**
 * 添加群组成员
 */
export var ADD_GROUP_MEMBER = "".concat(BASE_URL_ONLINE_DOCS, "group_addmember");
/**
 * 创建群组
 */
export var GROUP_CREATE = "".concat(BASE_URL_ONLINE_DOCS, "group_create");
/**
 * 单个群组信息
 */
export var GROUP_INFO = "".concat(BASE_URL_ONLINE_DOCS, "group_info");
/**
 * 退出群组
 */
export var GROUP_QUIT = "".concat(BASE_URL_ONLINE_DOCS, "group_quit");
/**
 * 创建群组状态检测
 */
export var GROUP_CHECK = "".concat(BASE_URL_ONLINE_DOCS, "group_checker");
/**
 * 将群号写入分享key
 */
export var ADD_KEY_TO_GROUP = "".concat(BASE_URL_ONLINE_DOCS, "group_addkey");
/**
 * 激活临时群
 */
export var GROUP_ACTIVATE = "".concat(BASE_URL_ONLINE_DOCS, "group_activate");
